import { useRef, useState } from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import AgreementSigningFields from './index';

export default function WorkerApplicationSigning() {
  const signatureCanvasRef = useRef<HTMLCanvasElement>(null);
  const [signatureData, setSignatureData] = useState('');
  const [signatureFirstName, setSignatureFirstName] = useState('');
  const [signatureLastName, setSignatureLastName] = useState('');
  const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] =
    useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const valid =
    signatureFirstName.trim() &&
    signatureLastName.trim() &&
    signatureData &&
    termsAndConditionsAccepted;
  const submit = () => {
    if (!valid || submitted) return;
    const bridge = (
      window as unknown as {
        WorkerSignature?: { postMessage: (value: string) => void };
      }
    ).WorkerSignature;
    if (!bridge) {
      setError(
        'Open this signing screen from your company application in the app.'
      );
      return;
    }
    setSubmitted(true);
    bridge.postMessage(
      JSON.stringify({
        firstName: signatureFirstName.trim(),
        lastName: signatureLastName.trim(),
        signature: signatureData,
        termsAccepted: true
      })
    );
  };
  return (
    <Box sx={{ background: '#fff', color: '#222', minHeight: '100vh', p: 2 }}>
      <Stack spacing={2} sx={{ maxWidth: 700, mx: 'auto' }}>
        <Typography variant="h5">Sign Company Agreement</Typography>
        <Typography>Sign the company agreement you just reviewed.</Typography>
        <AgreementSigningFields
          signatureCanvasRef={signatureCanvasRef}
          signatureData={signatureData}
          setSignatureData={setSignatureData}
          signatureFirstName={signatureFirstName}
          setSignatureFirstName={setSignatureFirstName}
          signatureLastName={signatureLastName}
          setSignatureLastName={setSignatureLastName}
          termsAndConditionsAccepted={termsAndConditionsAccepted}
          setTermsAndConditionsAccepted={setTermsAndConditionsAccepted}
        />
        {error && <Alert severity="error">{error}</Alert>}
        <Button
          variant="contained"
          disabled={!valid || submitted}
          onClick={submit}
        >
          Sign &amp; Apply
        </Button>
      </Stack>
    </Box>
  );
}
